import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/batteries/page.tsx");
